import { render, staticRenderFns } from "./formelement.vue?vue&type=template&id=73e772d8&"
import script from "./formelement.vue?vue&type=script&lang=js&"
export * from "./formelement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports